import styled from "styled-components";

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    flex-grow: 1;
    overflow-x: hidden;
`;

export default PageContainer;
